const GET_METHOD = "GET";
const POST_METHOD = "POST";
const PUT_METHOD = "PUT";
const PATCH_METHOD = "PATCH";
const DELETE_METHOD = "DELETE";

export { POST_METHOD, GET_METHOD, PUT_METHOD, PATCH_METHOD, DELETE_METHOD };
